import { CleanButton, theme, BodyMedium, BodySmall } from '@arnold/common';
import styled from '@emotion/styled/macro';
import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from '../../components/PageLayout';

export const FiltersContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: ${theme.spacing.e};
`;

export const FilterBox = styled.div`
  border: 1px solid #ededed;
  max-height: 500px;
  min-width: 277.33px;
  overflow-y: auto;
  z-index: 2147483640;
  padding: 9px 0;
  color: ${theme.colors.text.primary};
`;

export const Label = styled.div`
  color: ${theme.colors.text.secondary};
  padding-left: ${theme.spacing.f};
  padding-bottom: ${theme.spacing.c};
`;

export const SequenceFilterContainer = styled.div`
  width: calc((100% - 2rem) / 3);
  margin-right: 1rem;
  position: relative;
`;

type Props = {
  showFilters: boolean;
};

export const FilterModal = styled.div<Props>`
  position: absolute;
  z-index: 100000;
  top: calc(${theme.spacing.l} - ${theme.spacing.a});
  left: calc(50% - 7px);
  transform: translate(-50%);
  box-shadow: 0px 5px 30px -20px #00000080;
  border: ${theme.spacing.a} solid ${theme.colors.borderMain.default};
  padding: 0;
  max-width: calc(60rem - ${theme.spacing.h});
  width: 100%;
  display: ${(props) => (props.showFilters ? 'block' : 'none')};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${theme.background.primary};

  @media (max-width: ${theme.breakpoint.small}) {
    height: calc(100% - ${HEADER_HEIGHT} + 1px);
    top: calc(${HEADER_HEIGHT} - 1px);
    transform: none;
    left: 0;
  }

  @media (max-width: 576px) {
    height: calc(100% - ${HEADER_HEIGHT_MOBILE} + 1px);
    top: calc(${HEADER_HEIGHT_MOBILE} - 1px);
  }
`;

export const PredefinedFilter = styled(CleanButton)`
  color: ${theme.colors.actionPrimary.default};
  margin-left: ${theme.spacing.c};
  margin-right: ${theme.spacing.f};
  margin-top: ${theme.spacing.e};
  margin-bottom: ${theme.spacing.f};
  text-decoration: none;

  &:hover {
    color: ${theme.colors.actionPrimary.hover};
  }
  &:focus {
    color: ${theme.colors.actionPrimary.focused};
  }
`;

// Chart components
export const BarChartContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BarChartBody = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: row;
  ${({ width }) => (width ? `width: ${width};` : '')}
  gap: ${theme.spacing.b};
`;

export const ChartBarBox = styled.div<{ width: number; hideMobileMarginTop?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: ${({ width }) => width}%;

  @media (max-width: ${theme.breakpoint.small}) {
    margin-top: ${({ hideMobileMarginTop }) => (!hideMobileMarginTop ? theme.spacing.g : 0)};
    margin-bottom: ${theme.spacing.e};
  }
`;

export const ChartBar = styled.div<{ color: string; height?: string }>`
  width: 100%;
  height: ${({ height }) => height ?? '22px'};
  background-color: ${({ color }) => color};
`;

export const ChartBarValue = styled(BodyMedium)`
  font-weight: ${theme.typography.body.medium?.bold!.fontWeight};
  color: ${theme.colors.text.primary};
  white-space: nowrap;
  display: inline-block;
`;

export const ChartBarSpan = styled(BodySmall)`
  color: ${theme.colors.text.secondary};
  margin-top: ${theme.spacing.d};
  margin-bottom: ${theme.spacing.d};
`;

// Tooltip components
export const TooltipContent = styled.div<{ chartOptions: object[] }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing.f};

  ${({ chartOptions }) => chartOptions.length > 6 && 'flex-wrap: wrap; max-height: 400px;'};
`;

export const TooltipItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const CustomSingleValue = styled.div`
  color: hsl(0, 0%, 20%);
  margin-left: 2px;
  margin-right: 2px;
  max-width: calc(100% - 10px);
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  white-space: nowrap;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
`;
